import React from 'react';
import logo from './img/seduc-pi.svg';
import logoSeduc from '@/components/custom/logos-seduc/img/logo-seduc-horizontal.png';
import logoFlorianoEduca7 from '@/assets/images/floriano-educa-7/horizontal-logo.png';
import logoKubi from '@/assets/images/kubi/horizontal-logo.svg';
import logoDetranDf from '@/assets/images/detran-df/horizontal-logo.svg';
import { cn } from '@/lib/utils';

export default function HeaderPrinted(props) {
  const { institution } = props;
  const appName = process.env.REACT_APP_NAME;
  const isFlorianoEduca7 = appName === 'floriano-educa-7';
  const isKubi = appName === 'kubi';
  const isDetranDf = appName === 'detran-df';

  let subtitle = 'Secretaria de Educação - SEDUC/PI';
  let headerLogo = logoSeduc;
  if (isFlorianoEduca7) {
    subtitle = 'Floriano - Educa 7';
    headerLogo = logoFlorianoEduca7;
  } else if (isKubi) {
    subtitle = 'Kubi';
    headerLogo = logoKubi;
  } else if (isDetranDf) {
    subtitle = 'Departamento de Trânsito do Distrito Federal - DETRAN/DF';
    headerLogo = logoDetranDf;
  }

  return (
    <header className="printed-exam__header">
      <div className="printed-exam__inner-header">
        <h1 className="printed-exam__title">{institution}</h1>
        <p className="printed-exam__subtitle">{subtitle}</p>
      </div>
      {/* <img
        className="printed-exam__logo"
        src={logo}
        alt="logotipo"
      /> */}
      <img
        className={cn(isFlorianoEduca7 || isKubi || isDetranDf ? 'w-[160px]' : 'w-[220px]')}
        src={headerLogo}
        alt="logotipo"
      />
    </header>
  );
}
